import { Routes } from '@angular/router';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {AuthGuard} from '@core/services/auth-guard.service';

export const taxHubRoutes: Routes = [
  {
    path: 'administration/usage-report/orbitax-website',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/orbitax-website/by-user',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/orbitax-website/by-feature',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/orbitax-website/by-article',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/orbitax-website/by-feature/:FeatureId',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/orbitax-website/by-company/:RowId',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/orbitax-website/by-article/:ArticleId',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/orbitax-itp',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  }
];
